// reduce calling the function several time each msec

function debounce(func, timeout = 50) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

// select each image parent
let imagesContainer = document.querySelectorAll(
  '.product-wrap.has-secondary-media-swap a'
);

const screenCenter = window.innerHeight / 2;
// This checks if the current device is in fact mobile

let isMobile = window.matchMedia('(any-pointer:coarse)').matches;
let isMobile_2 =
  /(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i.test(
    navigator.userAgent
  );
let isMobile_3 = window.matchMedia(
  'only screen and (max-width: 768px)'
).matches;
let isMobile_4 = 'ontouchstart' in document.documentElement;

if (isMobile_2 || isMobile || isMobile_4 || isMobile_3) {
  // while scrolling run swapCollectionImage each 50ms
  if ($(window).width() < 798) {
    window.onscroll = debounce(() => swapCollectionImage());
  }
}
function swapCollectionImage() {
  if (imagesContainer) {
    imagesContainer.forEach(imgContainer => {
      let img2 = imgContainer.querySelectorAll('img')[0];
      let img1 = imgContainer.querySelectorAll('img')[1];

      let eachImgRect = imgContainer.getBoundingClientRect();
      let eachImgRectCenter = eachImgRect.top + eachImgRect.height * 0.5 - 50;
      if (eachImgRectCenter >= screenCenter) {
        // img1.classList.add("transition--fade-in lazyautosizes lazyloaded secondary-media-hidden")
        // img2.classList.add("transition--fade-in secondary lazypreload lazyautosizes lazyloaded")
        img1 && img1.classList.add('secondary-media-hidden');
        img1 && img1.classList.add('secondary');
        img2 && img2.classList.remove('secondary');
        img2 && img2.classList.remove('secondary-media-hidden');
      } else {
        img1 && img1.classList.remove('secondary-media-hidden');
        img1 && img1.classList.remove('secondary');
        img2 && img2.classList.add('secondary');
        img2 && img2.classList.add('secondary-media-hidden');
      }
    });
  }
}

// -----------------mobile menu  cart icon/ mini cart  ------
const cartMenuIcon = document.getElementById('top-menu_cart-icon');
if (window.PXUTheme.media_queries.medium.matches) {
  // add preventDefault() to 'a' element only to prevent page reload when cart-icon is clicked

  document
    .querySelector('#top-menu_cart-icon .icon-cart-dev.mini_cart')
    .addEventListener('click', e => e.preventDefault());

  cartMenuIcon.addEventListener('click', e => {
    // prevent scroll when mini-cart is open
    if (cartMenuIcon.classList.contains('active_link')) {
      document.body.classList.add('blocked-scroll');
      document.getElementsByTagName('html')[0].classList.add('lock-scroll');
    } else {
      document.body.classList.remove('blocked-scroll');
      document.getElementsByTagName('html')[0].classList.remove('lock-scroll');
    }
  });
  // add active_link once on first click
  cartMenuIcon.addEventListener(
    'click',
    function (e) {
      cartMenuIcon.classList.add('active_link');
      document.getElementsByTagName('html')[0].classList.add('lock-scroll');
      document.body.classList.add('blocked-scroll');
    },
    { once: true }
  );
}
//--------------------------/-----------------------------

// dpd slider
// $('.product_gallery.js-product-gallery').flickity();
// // 2nd carousel, navigation
// $('.product_gallery_nav').flickity({
//   asNavFor: '.product_gallery.js-product-gallery',
//   contain: true,
//   pageDots: false
// });
// var $carousel2 = $('.product_gallery').flickity({

//   wrapAround: false,
//   pageDots: false,
//   autoPlay: 10000
// });

// var $carousel = $('..product_gallery_nav').flickity({
//   asNavFor: '.product_gallery',
//   cellAlign: 'right',
//   prevNextButtons: true,
//   contain: true,
//   pageDots: false,
//   arrowShape: {
//       x0: 10,
//       x1: 70, y1: 50,
//       x2: 70, y2: 50,
//       x3: 35
//   }
// });
// $carousel.on( 'click', function(event, pointer, cellElement, cellIndex) {
//   console.log('oarsintoiearsntioaersntioersnt')
//   if ( typeof cellIndex == 'number' ) {
//       $carousel2.flickity( 'select', cellIndex );
//   }
// });

// code blow will sync thumbnails images with  main gallery image

{
  let productGallerySlidesCells = document
    .querySelector('#ftl_product_gallery')
    ?.querySelectorAll('.gallery-cell');
  let productGallerySlider = () => {
    return document.querySelector(
      '#ftl_product_gallery > .flickity-viewport .flickity-slider'
    );
  };
  let productThumbsContainer = document.querySelectorAll(
    '.product_gallery_nav.product-gallery__thumbnails'
  )[0];
  let productImagesThumbs = productThumbsContainer?.querySelectorAll(
    '.gallery-cell.product-gallery__thumbnail'
  );
  let getSliderBoundings = () => {
    carouselRect = document
      .querySelectorAll('.product_gallery ')[0]
      .getBoundingClientRect();
    carouselLeft = carouselRect.left;
    carouselRight = carouselRect.right;
    return [carouselLeft, carouselRight];
  };

  if (productThumbsContainer) {
    if (productImagesThumbs) {
      productImagesThumbs.forEach((eachThumb, thumbIndex) => {
        eachThumb.addEventListener('click', function () {
          //1) remove 'is-selected' from allsiblings
          productImagesThumbs.forEach(elem =>
            elem.classList.remove('is-selected', 'is-nav-selected')
          );

          //2 add 'is-selected' to current click on elem
          this.classList.add('is-selected', 'is-nav-selected');

          //  currentMainGallery.classList.remove('is-selected')
          //  currentMainGallery.classList.add('sd','hide-img')
          //  productGallerySlidesCells[thumbIndex].classList.remove('sd','hide-img')
          //  productGallerySlidesCells[thumbIndex].classList.add('s','is-selected')
          //  //get rect of the selected gallery

          //  let slideLeftDist = Math.ceil(productGallerySlidesCells[thumbIndex].getBoundingClientRect().left)

          // //left: 0px; transform: translateX(-101.37%);
          // // 0 translateX(0%)
          // // 1 translateX(-101.37%)
          // // 3 translateX(-202.75%)
          // // 4 translateX(-304.12%)
          //  //productGallerySlider().style.transform = `translateX(${slideLeftDist}px)`
          //  console.log(slideLeftDist)
          $('#ftl_product_gallery').flickity('select', thumbIndex, true, false);
        });
      });
    } else {
      console.log('elem not found -> productImagesThumbs');
    }
  } else {
    console.log('elem not found -> productThumbsContainer');
  }

  document
    .querySelectorAll('#ftl_product_gallery > button.flickity-button')
    .forEach(btn => {
      btn.addEventListener('click', () => {
        console.log(btn);

        let xx = Array.from(productGallerySlidesCells).find((elem, index) =>
          elem.classList.contains('is-selected')
        );

        // productImagesThumbs.forEach(elem=>elem.classList.remove('is-selected','is-nav-selected'))

        //            //2 add 'is-selected' to current click on elem
        // productImagesThumbs[currentMainGalleryIndex].classList.add('is-selected','is-nav-selected')
        console.log(xx);
      });
    });

  $('#ftl_product_gallery').on('settle.flickity', function () {
    productGallerySlidesCells.forEach((cell, index) => {
      if (cell.classList.contains('is-selected')) {
        productImagesThumbs.forEach(elem =>
          elem.classList.remove('is-selected', 'is-nav-selected')
        );

        //2 add 'is-selected' to current click on elem
        // productImagesThumbs[index].classList.add('is-selected','is-nav-selected')
        console.log('current thumb', productImagesThumbs[index]);
        let currenThumb = productImagesThumbs[index];
        currenThumb.classList.add('is-selected', 'is-nav-selected');
      }
    });
  });
}

// *********************************
// pdp form popup on Get The Fit section
{
  let sizeSwatchesInFromPopup = document.querySelectorAll(
    '#myModal1 .swatch_options .swatch.Size .swatch-element'
  );
  if (sizeSwatchesInFromPopup) {
    sizeSwatchesInFromPopup.forEach(each => {
      each.addEventListener('click', function () {
        sizeSwatchesInFromPopup.forEach(swatch => {
          swatch.classList.remove('__selected-variant');
          swatch.previousElementSibling.removeAttribute('checked');
        });
      });
    });

    sizeSwatchesInFromPopup.forEach((each, index) => {
      each.addEventListener('click', function () {
        this.previousElementSibling.checked = true;
        this.previousElementSibling.setAttribute('checked', '');
        document
          .querySelectorAll("#myModal1 select[name='id'] option")
          .forEach(selected => selected.removeAttribute('selected'));

        let selectedOption = document.querySelectorAll(
          "#myModal1 select[name='id'] option"
        )[index];
        selectedOption.setAttribute('selected', 'selected');
        console.log(selectedOption);
      });
    });
  }
}

//********************************* */
